var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-content-layout',[_c('app-sidebar',{attrs:{"items":_vm.menus}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }